export const HOCKEY_POSITIONS = [
  { pos: 1, label: "C", value: 13 }, // Center
  { pos: 2, label: "D", value: 14 }, // Defenseman
  { pos: 3, label: "LW", value: 16 }, // Left Wing
  { pos: 4, label: "RW", value: 15 }, // Right Wing
];

export const SOCCER_POSITIONS = [
  { pos: 1, label: "D", value: 1 }, // Defender
  { pos: 2, label: "M", value: 2 }, // Midfielder
  { pos: 3, label: "F", value: 3 }, // Forward
  { pos: 4, label: "G", value: 4 }, // Goalkeeper
];

export const BASKETBALL_POSITIONS = [
  { pos: 1, label: "BG", value: 5 }, // Guard
  { pos: 2, label: "BF", value: 6 }, // Forward
  { pos: 3, label: "BC", value: 7 }, // Center
];

export const FOOTBALL_POSITIONS = [
  { pos: 1, label: "QB", value: 25 }, // Quarterback
  { pos: 2, label: "WR", value: 26 }, // Wide Receiver
  { pos: 3, label: "TE", value: 27 }, // Tight End
  { pos: 4, label: "RB", value: 28 }, // Running Back
];

export const RUGBY_POSITIONS = [
  { pos: 1, label: "FB", value: 18 }, // Fullback
  { pos: 4, label: "HA", value: 21 }, // Halves
  { pos: 5, label: "HK", value: 22 }, // Hoocker
  { pos: 6, label: "MF", value: 23 }, // Middle Forward
  { pos: 7, label: "EF", value: 24 }, // Edge Forward
]

export const AUSTRALIAN_FOOTBALL_POSITIONS = [
  { pos: 1, label: "D", value: 1 }, // Defender
  { pos: 2, label: "M", value: 2 }, // Midfielder
  { pos: 3, label: "F", value: 3 }, // Forward
  { pos: 4, label: "R", value: 17 }, // Ruck
]

export const CRICKET_POSITIONS = [
  { pos: 1, label: "BL", value: 8 }, // Bowler
  { pos: 2, label: "BT", value: 9 }, // Batsman
  { pos: 4, label: "AR", value: 11 }, // All Rounder
]

export const getPositionsForSport = (sport) => {
  if (sport === "soccer") return SOCCER_POSITIONS;
  if (sport === "basketball") return BASKETBALL_POSITIONS;
  if (sport === "football") return FOOTBALL_POSITIONS;
  if (sport === "rugby") return RUGBY_POSITIONS;
  if (sport === "australian_football") return AUSTRALIAN_FOOTBALL_POSITIONS;
  if (sport === "cricket") return CRICKET_POSITIONS;
  return HOCKEY_POSITIONS;
};
